import styled from "styled-components"

export const Main = styled.div`
  margin-bottom: 50px;
  min-height: 138px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;

  p {
    font-size: 1.7rem;
    font-weight: 700;
    line-height: 2.25rem;
    letter-spacing: 0.06em;
    color: #030303;
    text-align: center;
  }
`

export const Wrapper = styled.div`
  width: 83.3%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: linear-gradient(
    79.38deg,
    #eae69c 0.31%,
    #bb913c 20.79%,
    #eae69c 45.01%,
    #bb913c 64.96%,
    #b6872d 99.69%
  );
  align-items: center;
  gap: 20px;
  padding: 25px 0;

  @media (max-width: 1149px) {
    width: 82.5%;
  }

  @media (max-width: 799px) {
    width: 88.88%;
  }
`
